<script setup>
import { defineProps, defineEmits} from "vue";
import LinhaDeRecebimentosResumo from "./LinhaDeRecebimentosResumo.vue";
import LinhaDeRecebimentosDetalhes from "./LinhaDeRecebimentosDetalhes.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "recebimento",
]);

const emits = defineEmits([
    "update:alteraRecebimento",
]);

//==================================================================//
//======================= Altera Recebimento =======================//
//==================================================================//

const alteraRecebimento = (update)=>{

    update.id = props?.recebimento?.id;
    emits('update:alteraRecebimento',update);

};

</script>

<template>

    <div class="c-table__row-group">

        <LinhaDeRecebimentosResumo
            :dado="props?.dado"
            :recebimento="props?.recebimento"
            @update:alteraRecebimento="alteraRecebimento"
        ></LinhaDeRecebimentosResumo>

        <LinhaDeRecebimentosDetalhes
            :dado="props?.dado"
            :recebimento="props?.recebimento"
        ></LinhaDeRecebimentosDetalhes>

    </div>

</template>

<style scoped>

.c-table__row-group{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>